module.exports = __webpack_public_path__ + "static/media/Streithofen.9a3033e5.webp";